// extracted by mini-css-extract-plugin
module.exports = {"credits":"_18Ynoq","creditsCheckbox":"-NTKIc"};